module.exports = __webpack_public_path__ + "assets/MARK_-_Enviroment.6065b25a.svg";